import { useEffect, useMemo } from 'react';
import { useClaimStore } from '../store/claimStore';

/**
 * Custom hook to handle screen navigation and progress tracking using screen codes
 * Automatically sets the current screen code and tracks completion via stepData
 *
 * @param screenCode - The screen code identifier (e.g., '02-00-GARANTIE', '03M-01-DETAILS')
 */
export const useScreenNavigation = (screenCode: string) => {
  const { setCurrentScreenCode, completeScreen, currentScreenCode, stepData } = useClaimStore();

  useEffect(() => {
    // Set the current screen code when component mounts
    setCurrentScreenCode(screenCode);
  }, [screenCode, setCurrentScreenCode]);

  const completeCurrentScreen = () => {
    // Note: completeScreen is now a no-op
    // Completion is tracked via stepData (when updateClaimData is called)
    completeScreen(screenCode);
  };

  // Calculate completed screen codes from stepData keys
  const completedScreenCodes = useMemo(() => {
    return Object.keys(stepData);
  }, [stepData]);

  return {
    currentScreenCode,
    completedScreenCodes,
    completeCurrentScreen
  };
};
